<template>
  <header class="app-modal-header" :class="{ 'app-modal-header--new': design === 'new' }">
    <div class="app-modal-header__copy">
      <span v-if="eyebrow || $slots.eyebrow" class="app-modal-header__eyebrow">
        <slot name="eyebrow">{{ eyebrow }}</slot>
      </span>
      <h2 :id="titleId" class="app-modal-header__title">{{ title }}</h2>
    </div>
    <app-modal-close
      ref="close"
      design="new"
      :label="`Close ${title}`"
      @click="$emit('close')"
    />
  </header>
</template>

<script>
import AppModalClose from './AppModalClose'

export default {
  name: 'AppModalHeader',
  components: { AppModalClose },
  props: {
    eyebrow: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      required: true
    },
    titleId: {
      type: String,
      default: ''
    },
    design: {
      type: String,
      required: true,
      validator: value => value === 'new'
    }
  },
  methods: {
    focusClose() {
      this.$refs.close.focus()
    }
  }
}
</script>

<style lang="scss" scoped>
.app-modal-header--new {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: $ui-space-16;
  padding: $ui-space-20 $ui-space-24;
  border-bottom: 1px solid $ui-line;
  background-color: $ui-surface;
  color: $ui-text;
  font-family: $ui-font-body;

  .app-modal-header__title {
    margin: $ui-space-4 0 0;
    color: $ui-ink;
    font-family: $ui-font-heading;
    font-size: $ui-font-size-entity-title;
    font-weight: 600;
    line-height: 1.2;
  }

  .app-modal-header__eyebrow {
    color: $ui-blue;
    font-size: $ui-font-size-body;
    font-weight: 600;
    letter-spacing: .05em;
    text-transform: uppercase;
  }

}

@media (max-width: 600px) {
  .app-modal-header--new {
    padding-right: $ui-space-16;
    padding-left: $ui-space-16;
  }
}
</style>
